package ru.chm.gradereport.ui.util

import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.toComposeImageBitmap
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import org.jetbrains.skia.Image

@OptIn(ExperimentalEncodingApi::class)
fun imageBitmapFromPngBase64(base64: String): ImageBitmap? {
    if (base64.isBlank()) return null
    return runCatching {
        val bytes = Base64.decode(base64)
        Image.makeFromEncoded(bytes).toComposeImageBitmap()
    }.getOrNull()
}
